type ParsedForecastConfig = {
	showScopingUI: boolean;
};

export const parseForecastConfig = (config: string): ParsedForecastConfig => {
	try {
		const parsed = JSON.parse(config);
		return { showScopingUI: parsed?.ShowScopingUI === true };
	} catch {
		return { showScopingUI: false };
	}
};

export default parseForecastConfig;
